/**
 * Returns the timezone offset in hours between UTC and the specified IANA time zone for a given date.
 *
 * @param {string} timeZone - The IANA time zone name (e.g., 'Asia/Bangkok' or 'Europe/Oslo').
 * @param {Date} [date] - Optional date to calculate the offset for. Defaults to current date/time if not provided.
 * @returns {number} The offset in hours (can be negative or positive, rounded to handle DST).
 */
function getTimezoneOffset(timeZone: string, date?: Date): number {
    // Get the current date
    const now = date || new Date();
    // Get the same moment in UTC
    const utc = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
    // Get the same moment in the target timezone
    const tz = new Date(now.toLocaleString('en-US', { timeZone }));
    // Offset in minutes
    const offsetMinutes = (tz.getTime() - utc.getTime()) / (1000 * 60);
    // Convert to hours and round (to handle DST, e.g. 60 or 120 minutes)
    return Math.round(offsetMinutes / 60);
}

export default getTimezoneOffset;
